/**
 * External Dependencies
 */
import 'jquery';
// import "core-js/stable";
// import "regenerator-runtime/runtime";


import Router from './util/Router';

import barbaInit from './barba';


// import LazyLoad from 'vanilla-lazyload'

import once from './routes/once'
import common from './routes/common'
import home from './routes/home'
import locations from './routes/locations'
import interactive from './routes/interactive'
import environmental from './routes/environmental'
// export const lazySelector = new LazyLoad({
//     elements_selector: '.data-load-img',
// })


const routes = new Router({
  common,
  home,
  locations,
  interactive,
  environmental,
})

jQuery(document).ready(() => {
    once.init()
    routes.loadEvents()
    barbaInit(routes)
});
// barba.init({
//     prevent: ({ el }) => el.classList && (el.classList.contains('no-app')),
//     transitions: [
//       {


//         leave(data) {
//             const done = this.async()



//             gsap.to(data.current.container, 0.35, {
//                 opacity: 0,
//                 y: '-30px',
//                 ease: 'power2.easeOut',
//                 onComplete: done,
//             })

//         },
//         enter(data) {
//             const done = this.async()
//             const $el = data.next.container

//             data.current.container.style.display = 'none'

//             window.scroll(0,0)
//             gsap.set($el, { opacity: 0, y: '100px', visibility: 'visible' })

//             if(data.next.namespace === 'home'){
//                 home.run()
//             }

//             gsap.to($el,
//               0.35,
//               {
//                 opacity: 1,
//                 y: 0,
//                 ease: 'power2.easeOut',
//                 onComplete: done,
//             })
//         },
//         afterEnter({ next }){
//             common.init()
//             common.finalize()
//             map.mapboxLoad(next.container)
//         },
//         once({next}){
//             once.init()
//             common.init()
//             if(next.namespace === 'home'){
//                 home.run()
//             }
//             if($(next.container).find('.map').length){
//                 map.mapboxLoad(next.container)
//             }
//         },
//         beforeEnter(){
//             $('.header-app').removeClass('header-app--scrolled')
//         },
//         afterOnce(){
//             once.finalize()
//             common.finalize()
//         },

//       },
//     ],
// })

jQuery(document).ready(function($){
  $('#menu_btn').click(function(){
    if($('.nav-primary').hasClass("menu-opened")) {
      $('.nav-primary').removeClass("menu-opened");
    } else {
      $('.nav-primary').addClass("menu-opened");
    }
  });

  $('.nav-primary li a').click(function(){
    $('.nav-primary').removeClass("menu-opened");
  });
});
